import { render, staticRenderFns } from "./CaretakerOrdersHeader.vue?vue&type=template&id=2d3a0f2c&"
import script from "./CaretakerOrdersHeader.vue?vue&type=script&lang=ts&"
export * from "./CaretakerOrdersHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CaretakerOrdersHeader.vue?vue&type=style&index=0&id=2d3a0f2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports